<template>
  <div class="article-container">
    <div class="title">{{info.title}}</div>
    <div class="desc">
      <span class="tag">原创</span>
      <span class="name">网站管理员</span>
      <span class="time">{{info.publishDate}}</span>
    </div>
    <!-- <div class="banner"><img v-if="info.coverIcon" :src="info.coverIcon" alt=""></div> -->
    <div class="content" v-html="info.content"></div>
    <div class="back-box" @click="back()"><img class="back" src="../../assets/images/activity/back.png" alt=""></div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      info: {}
    }
  },
  components: {
    
  },
  methods: {
    // 获取文章详情
    getArticleDetail(voteId){
      this.$api.activity.getArticleDetail(this.$route.query.id, {},res=>{
        this.info = res.data
      })
    },
    back(){
      if (window.history.length <= 1) {
          this.$router.push({path:'/'})
          return false
      } else {
          this.$router.go(-1)
      }
    }
  },
  mounted(){
    this.getArticleDetail()
  },
}
</script>

<style lang="scss" scoped>
.article-container{
  width: 100vw;
  height: 100vh;
  padding: 20px 16px;
  box-sizing: border-box;

  .title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .desc {
    color: rgba(0,0,0,0.3);
    font-size: 15px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .tag {
      display: inline-block;
      background: #f2f2f2;
      color: rgba(0,0,0,0.3);
      padding: 0 4px;
      margin-right: 8px;
      font-size: 12px;
      height: 18px;
      line-height: 18px
    }
    .name {
      margin-right: 8px
    }
    .time {
      margin-top: 2px
    }
  }

  .banner {

    img {
      width: 100%;
      height: auto;
    }
  }

  .content {
    color: #333;
    font-size: 15px;
    margin-top: 0.5em;

    ::v-deep img {
      width: 100%;
      height: auto;
    }

    ::v-deep video {
      width: 100%;
      height: auto;
    }

    
    ::v-deep iframe.ql-video {
      margin: 0 auto;
      display: flex;
      width: 100%;
      min-height: 200px;
    }

    ::v-deep p {
      line-height: 1.8em;
    }
  }

  .back-box {
    position: fixed;
    right: 2px;
    bottom: 20px;
    display: inline-block;
    text-align: right;
    border-radius: 10px
  }
  .back {
    width: 38px;
    height: auto;
  }
}
</style>
